import { Prettify, signalStore, withMethods } from '@ngrx/signals';
import { withSavedCart } from './features/withSavedCart';

export const SavedCartComponentStore = signalStore(
  withSavedCart(),
  withMethods((store) => {
    const selectCartById = (id: string | undefined | null) => {
      store._selectCartById(id ?? '');
    };
    return {
      selectCartById,
    };
  }),
);
export type SavedCartComponentStore = Prettify<InstanceType<typeof SavedCartComponentStore>>;
